module.exports = __webpack_public_path__ + "img/unload-5-2.04f43ff6.png";